export default __webpack_public_path__ + "static/media/mentor_mock_4.53112783.png";